module.exports = __webpack_public_path__ + "static/media/vocal.a1cf736c.jpg";